import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ChefBookingCard from "../components/ChefBookingCard";
import BookingForm from "../components/BookingForm";
import "../styles/ChefBooking.css";
import chef1 from "../assets/images/chef1.jpg";

/* ===== Madi Samayal Chefs (Priest / Vedic Cuisine) ===== */
const chefs = [
  {
    name: "Smt. Lalitha Ganesan",
    specialty:
      "Madi Samayal · Pure Veg · Jain & Sattvic Cooking · Iyer & Vedic Traditions",
    rating: 4.8,
    image: chef1,
  },
];

const ChefBooking = () => {
  const location = useLocation();

  /* ===== Handle navigation from Home page ===== */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get("type");

    if (type === "chef") {
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }, 300);
    }
  }, [location.search]);

  return (
    <div className="chef-booking-page">
      {/* ===== Header ===== */}
      <header className="chef-header">
        <h2>🕉️ Madi Samayal – Home Chef Bookings</h2>
        <p className="chef-intro">
          Book experienced <strong>Madi Samayal</strong> chefs who follow
          traditional Hindu cooking practices for poojas, homams, vrathams,
          temple functions, and priest households.
        </p>
        <p className="chef-intro">
          Food is prepared strictly following <strong>sattvic rules</strong> —
          no onion, no garlic, no root vegetables, and with full ritual
          discipline as required by Vedic customs.
        </p>
      </header>

      {/* ===== Chef Cards ===== */}
      <section className="chef-grid">
        {chefs.map((chef, idx) => (
          <ChefBookingCard key={idx} {...chef} />
        ))}
      </section>

      {/* ===== Booking Form ===== */}
      <section className="chef-booking-form">
        <h3>Request a Madi Samayal Chef</h3>
        <BookingForm type="Chef" />
      </section>
    </div>
  );
};

export default ChefBooking;
